import { CSSProperties } from 'react';
import './Logo.scss';

export type LogoVariant = 'mark' | 'mark-text' | 'white-mark' | 'white-mark-text';

export interface LogoProps {
  variant?: LogoVariant;
  size?: number;
  className?: string;
  tabIndex?: number;
  ariaLabel?: string;
}

export default function Logo({
  variant = 'mark',
  size = 32,
  className,
  tabIndex,
  ariaLabel = 'IT',
}: LogoProps) {
  const isWhite = variant === 'white-mark' || variant === 'white-mark-text';
  const hasText = variant === 'mark-text' || variant === 'white-mark-text';
  const src = isWhite ? '/icons/logo-white.svg' : '/icons/app-icon.svg';

  const classes = [
    'logo',
    `logo--${variant}`,
    isWhite ? 'logo--on-dark' : 'logo--on-light',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const style: CSSProperties = {
    ['--logo-size' as string]: `${size}px`,
  };

  return (
    <span className={classes} style={style} tabIndex={tabIndex} aria-label={ariaLabel} role="img">
      <img
        className="logo__mark"
        src={src}
        alt={ariaLabel}
        height={size}
        draggable={false}
      />
      {hasText && (
        <span className="logo__wordmark" aria-hidden="true">
          <span className="logo__sub">IT</span>
        </span>
      )}
    </span>
  );
}
